import axios from "axios"
import { CLIENT_FEATURES, CLIENT_FEATURES_HEADER } from "../clientFeatures"

// Tells the backend this front knows « On vous connaît déjà »: without it, an
// older bundle (store app before its OTA) gets the fast-track as it was. Sent
// on this call too, not only through the axios defaults set in App.js: the
// fast-track can run before they are.
const CLIENT_FEATURES_HEADERS = {
    [CLIENT_FEATURES_HEADER]: CLIENT_FEATURES,
}

function initFastTrack({}, data) {
    return axios.post("api/v1/fast-track/init", data, {
        headers: CLIENT_FEATURES_HEADERS,
    })
}

function submitFastTrackDiagnostic({}, data) {
    return axios.post(`/api/v1/fast-track/submit-diagnostic`, data)
}

function getAvailableTrialLiveSessions() {
    return axios.get(`/api/v1/fast-track/trial-slots`)
}

function chooseTrialSlot({}, data) {
    return axios.post(`/api/v1/fast-track/choose-trial-slot`, data)
}

function getUserTrialLiveSession({}, {}, params) {
    return axios.get(`/api/v1/fast-track/user-trial-live-session`, {
        params,
    })
}

function sendVerificationCode({}, data) {
    return axios.post(`/api/v1/fast-track/send-verification-code`, data)
}

function verifyVerificationCode({}, data) {
    return axios.post(`/api/v1/fast-track/verify-verification-code`, data)
}

function createStagePreInscription({}, data) {
    return axios.post("/api/v1/fast-track/create-stage-pre-inscription", data)
}

// « On vous connaît déjà » — the contact is resolved server-side from `token`,
// the page only ever holds it masked.
function sendRecognitionCode({}, { token, channel }) {
    return axios.post("/api/v1/fast-track/recognition/send-code", {
        token,
        channel,
    })
}

// Same payload as the code login (tokens, family), plus `recognition`.
function verifyRecognition({}, data) {
    return axios.post("/api/v1/fast-track/recognition/verify", data)
}

// Same payload as initFastTrack once the family has landed on an account.
function resolveRecognition({}, { token, child_id }) {
    return axios.post("/api/v1/fast-track/recognition/resolve", {
        token,
        child_id,
    })
}

function skipRecognition({}, { token }) {
    return axios.post("/api/v1/fast-track/recognition/skip", { token })
}

export const fastTrackService = {
    initFastTrack,
    sendRecognitionCode,
    verifyRecognition,
    resolveRecognition,
    skipRecognition,
    submitFastTrackDiagnostic,
    getAvailableTrialLiveSessions,
    chooseTrialSlot,
    getUserTrialLiveSession,
    sendVerificationCode,
    verifyVerificationCode,
    createStagePreInscription,
}
